import { render, staticRenderFns } from "./missingCauseForm.vue?vue&type=template&id=7204cb8d&"
import script from "./missingCauseForm.vue?vue&type=script&lang=js&"
export * from "./missingCauseForm.vue?vue&type=script&lang=js&"
import style0 from "./missingCauseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports